import { Injectable } from '@angular/core';
import { EnvironmentService } from '@lib/core/environment';
import { Uuid } from '@lib/core/type';
import { AuthHttpClient } from '@proget-shared/auth-http-client';
import { ResponseErrorFactory } from '@proget-shared/helper/response-error';
import { catchError, map, Observable, of } from 'rxjs';

import { ActiveDirectoryUserAttributeMapper } from './mapper/active-directory-user-attribute.mapper';
import { ActiveDirectoryUserAttribute } from './model/active-directory-user-attribute';

@Injectable({ providedIn: 'root' })
export class AccountSettingsRepository {
  constructor(
    private httpClient: AuthHttpClient,
    private environment: EnvironmentService
  ) {}

  public update(id: Uuid, firstName: string, lastName: string, email: string, username: string): Observable<void> {
    return this.httpClient
      .put<void>(`${this.environment.apiUrl}/user/${id}`, {
        firstName,
        lastName,
        email,
        username,
      });
  }

  public getTermsOfUse(): Observable<any> {
    return this.httpClient.get(`${this.environment.apiUrl}/terms-of-use/`, { responseType: 'text' })
      .pipe(
        catchError((error: any) => {
          throw ResponseErrorFactory.create(error);
        })
      );
  }

  public getTermsOfUseStatus(): Observable<{ accepted: boolean }> {
    return this.httpClient
      .get<{ accepted: boolean }>(`${this.environment.apiUrl}/terms-of-use/status`)
      .pipe(catchError(() => of({ accepted: true })));
  }

  public acceptTermsOfUse(): Observable<any> {
    return this.httpClient.post(`${this.environment.apiUrl}/terms-of-use/accept`, {});
  }

  public getUserAttributes(): Observable<ActiveDirectoryUserAttribute[]> {
    return this.httpClient
      .get(
        `${this.environment.apiUrl}/settings/ldap/active-directory/user-attributes`,
        { params: { omitForbiddenInterceptor: true } }
      )
      .pipe(
        map((responseJson: any): ActiveDirectoryUserAttribute[] => responseJson.map(ActiveDirectoryUserAttributeMapper.map)
        )
      );
  }
}
